import React from "react"
import PropTypes from "prop-types"
import { FormContainer, InputField, StandardModal } from "uikit"
import { Grid, Form } from "semantic-ui-react"

const ScenarioForm = ({
  data: {
    fields: { description },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Create Scenario",
  submitHeader = "",
  onCancel
}) => (
  <Form
    error={hasError}
    loading={isPending}
    className="AddModal__Form"
    onSubmit={onSubmit}
  >
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <InputField
            autoFocus
            field={description}
            label="Description"
            className="AddModal__FormField"
            placeholder="Untitled"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Form>
)

const CreateScenarioFormModal = props => (
  <StandardModal style={{ minHeight: "20em" }} defaultOpen={true}>
    <StandardModal.Header header="Create Scenario" />
    <StandardModal.Content>
      <ScenarioForm {...props} />
    </StandardModal.Content>
    <StandardModal.Actions
      submitLabel="Create"
      cancelLabel="Cancel"
      onSubmit={props.data.onSubmit}
      onCancel={props.onCancel}
      loading={props.data.isPending}
    />
  </StandardModal>
)

export const SCENARIO_SCHEMA = {
  description: {
    type: "string"
  }
}

export const CreateScenarioModal = FormContainer(SCENARIO_SCHEMA)(
  CreateScenarioFormModal
)

CreateScenarioModal.PropTypes = {
  submit: PropTypes.func,
  onCancel: PropTypes.func
}
